import { useState, useEffect } from 'react';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import { SOCIAL_MEDIA } from '../constants';

export const useSocialMediaSelection = () => {
    const [selectedSocialMedia, setSelectedSocialMedia] = useState<any>(SOCIAL_MEDIA?.[0]);

    const selectSocialMedia = (item: any) => {
        EncryptedStorage.setItem('selectedSocialMedia', JSON.stringify(item));
        setSelectedSocialMedia(item);
    };

    const removeSelectedSocialMedia = () => {
        setSelectedSocialMedia(SOCIAL_MEDIA?.[0]);
        EncryptedStorage.removeItem("selectedSocialMedia");
    };

    useEffect(() => {
        removeSelectedSocialMedia();
        return () => {
            EncryptedStorage.removeItem("selectedSocialMedia");
        };
    }, []);

    return {
        selectedSocialMedia,
        selectSocialMedia,
        removeSelectedSocialMedia
    };
};
